import { render, staticRenderFns } from "./betterScroll.vue?vue&type=template&id=74bd076f&scoped=true"
import script from "./betterScroll.vue?vue&type=script&lang=js"
export * from "./betterScroll.vue?vue&type=script&lang=js"
import style0 from "./betterScroll.vue?vue&type=style&index=0&id=74bd076f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd076f",
  null
  
)

export default component.exports